<template>
  <div>
    <router-link :to="{ name: 'enterprise-map-view' }" target="_blank">
      <div
        class="grid-menu-icon-button"
        :class="{ 'mobile-grid-menu-icon-button': isMobileDevice }"
      >
        <vx-tooltip text="グリッドマップ" position="right">
          <div class="grid-menu-icon cursor-pointer" />
        </vx-tooltip>
      </div>
    </router-link>
  </div>
</template>

<script>
/**
 * グリッドマップ画面を別タブに開く
 * @parent LiveMap
 */
export default {
  name: "A.GridMenuIconButton",
  props: {
    isMobileDevice: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/mixin";
@import "@/assets/scss/aisea/_variables.scss";

.grid-menu-icon-button {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 3;

  &.mobile-grid-menu-icon-button {
    @media screen and (max-width: $min-width-iphone-8) {
      position: fixed;
      top: 16px;
      left: 66px;
    }

    @media screen and (min-width: ($min-width-iphone-8 + 1)) and (max-width: $max-width-ipad-pro-12) {
      left: 70px;
    }
    .grid-menu-icon {
      height: 40px;
      width: 40px;
      border-radius: 5px;
    }
  }

  .grid-menu-icon {
    @include image-button("md");
    background: url("../../assets/images/icons/lolcal/grid_map_default.svg")
      no-repeat;
    background-size: contain;

    &:hover {
      background: url("../../assets/images/icons/lolcal/grid_map_hover.svg")
        no-repeat;
      background-size: contain;
    }

    &:active {
      background: url("../../assets/images/icons/lolcal/grid_map_click.svg")
        no-repeat;
      background-size: contain;
    }
  }
}
</style>
